import {
  SelectListOption,
  generateSelectListOptions
} from '@shared/components/form-fields/select-list-option';

export enum ContactType {
  Client = 'Client',
  Prospect = 'Prospect',
  Referrer = 'Referrer'
}

export const contactTypes: SelectListOption[] = generateSelectListOptions(
  Object.values(ContactType)
);
